<h3>{{ 'titulo_info_puntuacion' | translate }}</h3>

<p [innerHTML]="'texto_1_info_puntuacion' | translate"></p>

<p [innerHTML]="'texto_2_info_puntuacion' | translate"></p>

<ul>
  <li [innerHTML]="'texto_3_info_puntuacion' | translate"></li>
  <li [innerHTML]="'texto_4_info_puntuacion' | translate"></li>
  <li [innerHTML]="'texto_5_info_puntuacion' | translate"></li>
</ul>
